import {
  makeObservable,
  action,
  observable,
  reaction,
} from 'mobx';
import {
  LoadingState,
} from '../BackendEntity';
import type {
  Meta,
} from './types';

export class ListBackendEntity<EntityType> {
  @observable private _data: EntityType[] = [];

  @observable private _meta: Meta = {} as any;

  @observable private _loadingState: LoadingState = LoadingState.IDLE;

  get data(): EntityType[] {
    return this._data;
  }

  get meta(): Meta {
    return this._meta;
  }

  get options() {
    return this._options;
  }

  @action private setOptions(options: any) {
    this._options = options;
  }

  get loadingState(): LoadingState {
    return this._loadingState;
  }

  @action private setLoadingState(loadingState: LoadingState) {
    this._loadingState = loadingState;
  }

  @action _setData(data: EntityType[], update = true) {
    if (update) {
      this._storeInstance[this._observableName] = data;
    }
    this._data = data;
  }

  async updateOptions(options: any) {
    this.setOptions(options);
    await this.fetch();
  }

  constructor(
    private _storeInstance: any,
    private _observableName: string,
    private _fetchData: (options?: any) => Promise<EntityType[]> | {data: Promise<EntityType[]>, meta: Meta},
    private _options?: any,
  ) {
    makeObservable(this);
    reaction(
      () => JSON.stringify(_storeInstance[_observableName]),
      (value) => {
        this._setData(JSON.parse(value), false);
      },
    );
  }

  async fetch() {
    try {
      this.setLoadingState(LoadingState.LOADING);
      const response: any = await this._fetchData(this.options);
      this._meta = response.meta;
      this._setData(response.data || response);
      this.setLoadingState(LoadingState.SUCCEEDED);
    } catch (error) {
      this.setLoadingState(LoadingState.FAILED);
    }
  }
}
